import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "modal-wrap default-modal" }
const _hoisted_2 = {
  class: "modal fade",
  id: "detailModal",
  tabindex: "-1",
  "aria-labelledby": "detailModalLabel",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "iconed-block-list" }
const _hoisted_7 = { class: "icon-wrap" }
const _hoisted_8 = {
  key: 0,
  class: "fas fa-file-image"
}
const _hoisted_9 = {
  key: 1,
  class: "fa fa-file-pdf"
}
const _hoisted_10 = {
  key: 2,
  class: "fa fa-file-csv"
}
const _hoisted_11 = {
  key: 3,
  class: "fas fa-file-word"
}
const _hoisted_12 = {
  key: 4,
  class: "fas fa-file-excel"
}
const _hoisted_13 = {
  key: 5,
  class: "fa fa-folder"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_17 = { class: "modal-body" }
const _hoisted_18 = { class: "ck-file-details" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "row mx-sm-n1 mb-2" }, [
  /*#__PURE__*/_createVNode("div", { class: "col-sm-3 px-md-1" }, [
    /*#__PURE__*/_createVNode("p", null, [
      /*#__PURE__*/_createVNode("strong", null, "Type")
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "col-sm-9 px-md-1" }, [
    /*#__PURE__*/_createVNode("p", null, "Folder")
  ])
], -1)
const _hoisted_20 = {
  key: 0,
  class: "row mx-sm-n1 mb-2"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "col-sm-3 px-md-1" }, [
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("strong", null, "Size")
  ])
], -1)
const _hoisted_22 = { class: "col-sm-9 px-md-1" }
const _hoisted_23 = {
  key: 1,
  class: "row mx-sm-n1 mb-2"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "col-sm-3 px-md-1" }, [
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("strong", null, "Owner")
  ])
], -1)
const _hoisted_25 = { class: "col-sm-9 px-md-1" }
const _hoisted_26 = {
  key: 2,
  class: "row mx-md-n1"
}
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "col-md-2 px-md-1" }, [
  /*#__PURE__*/_createVNode("p", null, "Modified")
], -1)
const _hoisted_28 = { class: "col-sm-9 px-md-1" }
const _hoisted_29 = {
  key: 3,
  class: "row mx-sm-n1 mb-2"
}
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "col-sm-3 px-md-1" }, [
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("strong", null, "Sub Folders")
  ])
], -1)
const _hoisted_31 = { class: "col-sm-9 px-md-1" }
const _hoisted_32 = {
  key: 4,
  class: "row mx-sm-n1 mb-2"
}
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "col-sm-3 px-md-1" }, [
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("strong", null, "Files")
  ])
], -1)
const _hoisted_34 = { class: "col-sm-9 px-md-1" }
const _hoisted_35 = {
  key: 5,
  class: "row mx-sm-n1 mb-2"
}
const _hoisted_36 = /*#__PURE__*/_createVNode("div", { class: "col-sm-3 px-md-1" }, [
  /*#__PURE__*/_createVNode("p", null, "Opened")
], -1)
const _hoisted_37 = { class: "col-sm-9 px-md-1" }
const _hoisted_38 = {
  key: 6,
  class: "row mx-sm-n1 mb-2"
}
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "col-sm-3 px-md-1" }, [
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("strong", null, "Created")
  ])
], -1)
const _hoisted_40 = {
  key: 0,
  class: "col-sm-9 px-md-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("ul", null, [
                _createVNode("li", null, [
                  _createVNode("span", _hoisted_7, [
                    (_ctx.selected.filetype === 'png' || _ctx.selected.filetype === 'jpg'|| _ctx.selected.filetype === 'jpeg')
                      ? (_openBlock(), _createBlock("i", _hoisted_8))
                      : (_ctx.selected.filetype === 'pdf')
                        ? (_openBlock(), _createBlock("i", _hoisted_9))
                        : (_ctx.selected.filetype === 'csv')
                          ? (_openBlock(), _createBlock("i", _hoisted_10))
                          : (_ctx.selected.filetype === 'doc' || _ctx.selected.filetype === 'docx')
                            ? (_openBlock(), _createBlock("i", _hoisted_11))
                            : (_ctx.selected.filetype === 'xls' || _ctx.selected.filetype === 'xlsx')
                              ? (_openBlock(), _createBlock("i", _hoisted_12))
                              : (_openBlock(), _createBlock("i", _hoisted_13))
                  ]),
                  (_ctx.selected.name)
                    ? (_openBlock(), _createBlock("h5", _hoisted_14, _toDisplayString(_ctx.selected.name), 1))
                    : (_openBlock(), _createBlock("h5", _hoisted_15, _toDisplayString(_ctx.selected.filename), 1))
                ])
              ])
            ]),
            _createVNode("button", {
              type: "button",
              class: "close",
              "data-dismiss": "modal",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeDetailModal && _ctx.closeDetailModal(...args))),
              "aria-label": "Close"
            }, [
              _hoisted_16
            ])
          ]),
          _createVNode("div", _hoisted_17, [
            _createVNode("div", _hoisted_18, [
              _hoisted_19,
              (_ctx.selected.size)
                ? (_openBlock(), _createBlock("div", _hoisted_20, [
                    _hoisted_21,
                    _createVNode("div", _hoisted_22, [
                      _createVNode("p", null, _toDisplayString(_ctx.selected.size), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.selected.created_by && _ctx.selected.created_by.full_name)
                ? (_openBlock(), _createBlock("div", _hoisted_23, [
                    _hoisted_24,
                    _createVNode("div", _hoisted_25, [
                      _createVNode("p", null, _toDisplayString(_ctx.selected.created_by.full_name), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.selected.modified_date)
                ? (_openBlock(), _createBlock("div", _hoisted_26, [
                    _hoisted_27,
                    _createVNode("div", _hoisted_28, [
                      _createVNode("p", null, _toDisplayString(_ctx.selected.modified_date), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.selected.child_folders && _ctx.selected.child_folders.length)
                ? (_openBlock(), _createBlock("div", _hoisted_29, [
                    _hoisted_30,
                    _createVNode("div", _hoisted_31, [
                      _createVNode("p", null, _toDisplayString(_ctx.selected.child_folders.length), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.selected.files)
                ? (_openBlock(), _createBlock("div", _hoisted_32, [
                    _hoisted_33,
                    _createVNode("div", _hoisted_34, [
                      _createVNode("p", null, _toDisplayString(_ctx.selected.files.length), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.selected.opened_date)
                ? (_openBlock(), _createBlock("div", _hoisted_35, [
                    _hoisted_36,
                    _createVNode("div", _hoisted_37, [
                      _createVNode("p", null, _toDisplayString(_ctx.selected.opened_date) + " by Me", 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.selected.created_date)
                ? (_openBlock(), _createBlock("div", _hoisted_38, [
                    _hoisted_39,
                    (_ctx.selected.created_date && _ctx.selected.created_by && _ctx.selected.created_by.full_name)
                      ? (_openBlock(), _createBlock("div", _hoisted_40, [
                          _createVNode("p", null, _toDisplayString(_ctx.selected.created_date) + " by " + _toDisplayString(_ctx.selected.created_by.full_name), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}